module.exports = __webpack_public_path__ + "img/logo-drontal.a009ff01.png";